import { calendarMonthsBefore } from './calendar-months-before';

export const AUDIT_LOG_RETENTION_MONTHS = 12;

/**
 * Calendar months in UTC fields rather than a day count: the dashboard promises
 * the last N calendar months, and no day multiplier lands on that boundary.
 */
export function auditLogRetentionCutoff(now: Date): Date {
  return calendarMonthsBefore(now, AUDIT_LOG_RETENTION_MONTHS);
}
